export interface ProductCustomization {
  font_style?: string | null;
  bottle_text?: string | null;
  design?: string | null;
  clothing_size?: string | null;
  clothing_customization?: string | null;
}

export interface CartItem {
  id: string;
  sku: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
  customization?: ProductCustomization;
}

export const generateUniqueId = (): string => {
  return `${Date.now()}-${Math.floor(Math.random() * 1000)}`;
};

export const createEmptyCartItemWithCustom = (): CartItem => {
  return {
    id: generateUniqueId(),
    sku: 0,
    name: "",
    price: 0,
    quantity: 1,
    image: "",
    customization: {
      font_style: null,
      bottle_text: null,
      design: null,
      clothing_size: null,
    },
  };
};

// Function to generate an empty CartItem without customization
export const createEmptyCartItemNoCustom = (): CartItem => {
  return {
    id: generateUniqueId(),
    sku: 0,
    name: "",
    price: 0,
    quantity: 1,
    image: "",
  };
};
